import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import useClick from '../use-click';
import useEventListener from '../use-event-listener/use-event-listener';
import useScroll from '../use-scroll/use-scroll';
export default function useUserInteraction() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    anyInteraction = _useState2[0],
    setAnyInteraction = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    anyScrollInteraction = _useState4[0],
    setAnyScrollInteraction = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    anyClickInteraction = _useState6[0],
    setAnyClickInteraction = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    anyMoveInteraction = _useState8[0],
    setAnyMoveInteraction = _useState8[1];
  function onAnyInteraction() {
    setAnyInteraction(true);
  }
  function onAnyScrollInteraction() {
    setAnyScrollInteraction(true);
    onAnyInteraction();
  }
  function onAnyClickInteraction() {
    setAnyClickInteraction(true);
    onAnyInteraction();
  }
  function onAnyMoveInteraction() {
    setAnyMoveInteraction(true);
    onAnyInteraction();
  }
  useScroll({
    onScroll: function onScroll() {
      if (window.scrollY > 0) {
        onAnyScrollInteraction();
      }
    },
    once: function once() {
      return window.scrollY > 0;
    }
  });
  useClick({
    onClick: onAnyClickInteraction,
    once: true
  });
  useEventListener('mousemove', onAnyMoveInteraction, {
    once: true
  });
  useEventListener('touchstart', onAnyMoveInteraction, {
    once: true
  });
  return {
    anyInteraction: anyInteraction,
    anyScrollInteraction: anyScrollInteraction,
    anyClickInteraction: anyClickInteraction,
    anyMoveInteraction: anyMoveInteraction
  };
}